import {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import axios from 'axios';
import routes from 'routes';
import permissions from 'permissions';
import rules from 'rbac-rules';
import {check} from 'components/RBAC/AccessControl';

export default (adId) => {
    const [isLoading, setIsLoading] = useState(true);
    const [ad, setAd] = useState(null);
    const {role} = useSelector(state => state.users.currentUser);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await axios.get(`${routes.violations.endpoint}/${adId}`);
                setAd(result.data.data);
            } catch (error) {
                console.log(error);
            } finally {
                setIsLoading(false);
            }
        };
        if (check(rules, role, [permissions.violations.list])) {
            setIsLoading(true);
            fetchData();
        }
    }, []);

    return {isLoading, adViolation: ad};
}
